import React from "react";
import Layout from "../../components/layout";
import { Link } from "react-router-dom";

import styles from "./NotFoundPage.module.scss";
import { route } from "../../static/route";

const NotFoundPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  return (
    <Layout>
      <div className={styles.NotFoundPage}>
        <div className="logoSection">
          <h1 className="text-4xl font-bold text-white lg:text-2xl">
            {companyName}
          </h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>
        <div className="mt-[70px] px-10 py-5 text-center">
          <p className="mt-4 text-primary-2 font-bold text-2xl">
            Page Not Found (404)
          </p>
          <p className="mt-4 text-primary-2 font-semibold text-lg">
            Sorry, the page you are looking for is not available on our website.
            Maybe you entered the wrong URL or the page has been removed by us.
          </p>
          <p className="mt-4 text-primary-2 font-semibold text-lg">
            Go to the main page: To view the main page of our website, please
            click{` `}
            <Link to={route.home}>
              <a className="text-xl font-bold underline">here.</a>
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  );
};
export default NotFoundPage;
